<template>
  <div>
    <!-- <b-button variant="primary" @click="showModal = true">
      {{ $store.state.kpi.openModal }}
    </b-button> -->

    <b-modal id="modal-input" v-model="showModal" size="xl" :title="$store.state.kpi.modalTitle" hide-footer scrollable>
      <b-container>
        <b-card>
          <b-row>
            <b-col>
              <b-card>
                <b-card-body>
                  <h2>{{ $store.state.kpi.title }}</h2>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-card>
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.email" label-cols-md="4">
                      <b-form-input type="text" v-model="data.email"></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.namaPenilai" label-cols-md="4">
                      <b-form-input type="text" v-model="data.namaPenilai"></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.jabatanPenilai" label-cols-md="4">
                      <b-form-input type="text" v-model="data.jabatanPenilai"></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.tempatTugas" label-cols-md="4">
                      <b-form-input type="text" v-model="data.tempatTugas"></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.tanggalPenilaian" label-cols-md="4">
                      <DatePicker style="width: 100%" v-model="data.tanggalPenilaian"></DatePicker>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.namaKaryawan" label-cols-md="4">
                      <b-form-input type="text" v-model="data.namaKaryawan"></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$store.state.kpi.tugasKerjaKaryawan" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.namaPosisi" :options="optionsRoles" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-card>
                <b-card-header class="bg-info"
                  ><h4>{{ $store.state.kpi.aspekKepribadian }}</h4></b-card-header
                >
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian1" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian1" :options="options1" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian2" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian2" :options="options2" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian3" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian3" :options="options3" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian4" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian4" :options="options4" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian5" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian5" :options="options5" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>

              <b-card>
                <b-card-header class="bg-info"
                  ><h4>{{ $store.state.kpi.aspekKomunikasi }}</h4></b-card-header
                >
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian6" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian6" :options="options6" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian7" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian7" :options="options7" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian8" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian8" :options="options8" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian9" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian9" :options="options9" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian10" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian10" :options="options10" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>

              <b-card>
                <b-card-header class="bg-info"
                  ><h4>{{ $store.state.kpi.teknisPekerjaan }}</h4></b-card-header
                >
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian11" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian11" :options="options11" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian12" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian12" :options="options12" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian13" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian13" :options="options13" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian14" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian14" :options="options14" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian15" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian15" :options="options15" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>

              <b-card>
                <b-card-header class="bg-info"
                  ><h4>{{ $store.state.kpi.aspekProduktivitas }}</h4></b-card-header
                >
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian16" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian16" :options="options16" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian17" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian17" :options="options17" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian18" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian18" :options="options18" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian19" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian19" :options="options19" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.penilaian20" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group v-model="data.penilaian20" :options="options20" :aria-describedby="ariaDescribedby" name="radio-stacked" stacked class="pl-2"></b-form-radio-group>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>

              <b-card>
                <b-card-header class="bg-info"
                  ><h4>{{ $store.state.kpi.catatanTentangKaryawan }}</h4></b-card-header
                >
                <b-card-body>
                  <b-form>
                    <b-form-group :label="$store.state.kpi.catatanKhusus" label-cols-md="4">
                      <b-form-input type="text" v-model="data.catatanKhusus"></b-form-input>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.persetujuanPenandatanganan" label-cols-md="4" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        v-model="data.persetujuanPenandatanganan"
                        :options="optionsSetuju"
                        :aria-describedby="ariaDescribedby"
                        name="radio-stacked"
                        stacked
                        class="pl-2"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-form>

                  <b-form>
                    <b-form-group :label="$store.state.kpi.jangkaWaktuKerjaLabel" label-cols-md="4">
                      <b-form-input type="number" v-model="data.jangkaWaktuKerja"></b-form-input>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

          <b-card-footer>
            <b-row>
              <b-col>
                <center>
                  <b-button variant="danger" @click="reset()">
                    {{ $store.state.kpi.kosongkanForm }}
                  </b-button>
                </center>
              </b-col>
              <b-col>
                <center>
                  <b-button variant="success" @click="register" :disabled="isValid">
                    {{ $store.state.kpi.kirimPenilaian }}
                  </b-button>
                </center>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data() {
    return {
      showModal: false,
      // form data (nilai jawaban)
      data: {
        email: null,
        namaPenilai: null,
        jabatanPenilai: null,
        tempatTugas: null,
        tanggalPenilaian: null,
        catatanKhusus: null,
        persetujuanPenandatanganan: null,
        jangkaWaktuKerja: null,
        poin: null,
        namaKaryawan: null,
        namaPosisi: null,
        totalPoin: 0,
        penilaian1: 0,
        penilaian2: 0,
        penilaian3: 0,
        penilaian4: 0,
        penilaian5: 0,
        penilaian6: 0,
        penilaian7: 0,
        penilaian8: 0,
        penilaian9: 0,
        penilaian10: 0,
        penilaian11: 0,
        penilaian12: 0,
        penilaian13: 0,
        penilaian14: 0,
        penilaian15: 0,
        penilaian16: 0,
        penilaian17: 0,
        penilaian18: 0,
        penilaian19: 0,
        penilaian20: 0,
      },
    };
  },
  validations: {
    data: {
      email: { required },
      namaPenilai: { required },
      jabatanPenilai: { required },
      tempatTugas: { required },
      tanggalPenilaian: { required },
      catatanKhusus: { required },
      persetujuanPenandatanganan: { required },
      jangkaWaktuKerja: { required },
      poin: { required },
      namaKaryawan: { required },
      namaPosisi: { required },
      totalPoin: { required },
      penilaian1: { required },
      penilaian2: { required },
      penilaian3: { required },
      penilaian4: { required },
      penilaian5: { required },
      penilaian6: { required },
      penilaian7: { required },
      penilaian8: { required },
      penilaian9: { required },
      penilaian10: { required },
      penilaian11: { required },
      penilaian12: { required },
      penilaian13: { required },
      penilaian14: { required },
      penilaian15: { required },
      penilaian16: { required },
      penilaian17: { required },
      penilaian18: { required },
      penilaian19: { required },
      penilaian20: { required },
    },
  },
  computed: {
    isValid() {
      return !this.$v.data.$invalid;
    },

    totalss() {
      let x = 0;
      for (let i = 1; i <= 20; i++) {
        x += this.data["penilaian" + i];
      }
      return x;
    },

    // opsi posisi (radio tugas kerja karyawan)
    optionsRoles() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.optionsRoles_1 || this.$store.state.kpi.optionsRoles[0], value: "Petugas Kebersihan" },
        { text: s.optionsRoles_2 || this.$store.state.kpi.optionsRoles[1], value: "Pengemudi" },
        { text: s.optionsRoles_3 || this.$store.state.kpi.optionsRoles[2], value: "Pesuruh" },
        { text: s.optionsRoles_4 || this.$store.state.kpi.optionsRoles[3], value: "Satpam" },
      ];
    },

    optionsSetuju() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.optionsSetuju_1 || this.$store.state.kpi.optionsSetuju[0], value: true },
        { text: s.optionsSetuju_2 || this.$store.state.kpi.optionsSetuju[1], value: false },
      ];
    },
    options1() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options1_1 || this.$store.state.kpi.options1[0], value: 3 },
        { text: s.options1_2 || this.$store.state.kpi.options1[1], value: 2 },
        { text: s.options1_3 || this.$store.state.kpi.options1[2], value: 1 },
      ];
    },
    options2() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options2_1 || this.$store.state.kpi.options2[0], value: 3 },
        { text: s.options2_2 || this.$store.state.kpi.options2[1], value: 2 },
        { text: s.options2_3 || this.$store.state.kpi.options2[2], value: 1 },
      ];
    },

    options3() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options3_1 || this.$store.state.kpi.options3[0], value: 3 },
        { text: s.options3_2 || this.$store.state.kpi.options3[1], value: 2 },
        { text: s.options3_3 || this.$store.state.kpi.options3[2], value: 1 },
      ];
    },

    options4() {
      return this.options1;
    },

    options5() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options5_1 || this.$store.state.kpi.options5[0], value: 3 },
        { text: s.options5_2 || this.$store.state.kpi.options5[1], value: 2 },
        { text: s.options5_3 || this.$store.state.kpi.options5[2], value: 1 },
      ];
    },

    options6() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options6_1 || this.$store.state.kpi.options6[0], value: 3 },
        { text: s.options6_2 || this.$store.state.kpi.options6[1], value: 2 },
        { text: s.options6_3 || this.$store.state.kpi.options6[2], value: 1 },
      ];
    },

    options7() {
      return this.options2;
    },
    options8() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options8_1 || this.$store.state.kpi.options8[0], value: 3 },
        { text: s.options8_2 || this.$store.state.kpi.options8[1], value: 2 },
        { text: s.options8_3 || this.$store.state.kpi.options8[2], value: 1 },
      ];
    },
    options9() {
      return this.options2;
    },
    options10() {
      return this.options2;
    },

    options11() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options11_1 || this.$store.state.kpi.options11[0], value: 3 },
        { text: s.options11_2 || this.$store.state.kpi.options11[1], value: 2 },
        { text: s.options11_3 || this.$store.state.kpi.options11[2], value: 1 },
      ];
    },

    options12() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options12_1 || this.$store.state.kpi.options12[0], value: 3 },
        { text: s.options12_2 || this.$store.state.kpi.options12[1], value: 2 },
        { text: s.options12_3 || this.$store.state.kpi.options12[2], value: 1 },
      ];
    },

    options13() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options13_1 || this.$store.state.kpi.options13[0], value: 3 },
        { text: s.options13_2 || this.$store.state.kpi.options13[1], value: 2 },
        { text: s.options13_3 || this.$store.state.kpi.options13[2], value: 1 },
      ];
    },

    options14() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options14_1 || this.$store.state.kpi.options14[0], value: 3 },
        { text: s.options14_2 || this.$store.state.kpi.options14[1], value: 2 },
        { text: s.options14_3 || this.$store.state.kpi.options14[2], value: 1 },
      ];
    },

    options15() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options15_1 || this.$store.state.kpi.options15[0], value: 3 },
        { text: s.options15_2 || this.$store.state.kpi.options15[1], value: 2 },
        { text: s.options15_3 || this.$store.state.kpi.options15[2], value: 1 },
      ];
    },

    options16() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options16_1 || this.$store.state.kpi.options16[0], value: 3 },
        { text: s.options16_2 || this.$store.state.kpi.options16[1], value: 2 },
        { text: s.options16_3 || this.$store.state.kpi.options16[2], value: 1 },
      ];
    },

    options17() {
      return this.options2;
    },

    options18() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options18_1 || this.$store.state.kpi.options18[0], value: 3 },
        { text: s.options18_2 || this.$store.state.kpi.options18[1], value: 2 },
        { text: s.options18_3 || this.$store.state.kpi.options18[2], value: 1 },
      ];
    },

    options19() {
      return this.options2;
    },

    options20() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.options20_1 || this.$store.state.kpi.options20[0], value: 3 },
        { text: s.options20_2 || this.$store.state.kpi.options20[1], value: 2 },
        { text: s.options20_3 || this.$store.state.kpi.options20[2], value: 1 },
      ];
    },
  },
  methods: {
    register() {
      this.data.totalPoin = this.totalss;
      this.$axios
        .post("penilaianKinerja/register", this.data)
        .then((res) => {
          if (res.data.status == 200) {
            this.$store.commit("set_alert", {
              variant: "success",
              msg: this.$store.state.kpi.successMsg || this.$store.state.kpi.successMsg,
              showing: true,
            });
            this.$router.push({ path: "/loker" });
          }
        })
        .catch((err) => {
          this.$store.commit("set_alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
    reset() {
      Object.keys(this.data).forEach((k) => {
        this.data[k] = k === "totalPoin" ? 0 : null;
      });
    },
  },
};
</script>
